const AndroidDownloadBadge = ({
  width = 131,
  height = 39,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 200 60"
    role="img"
    aria-label="Get it on Android"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="199"
      height="59"
      rx="10"
      fill="#000000"
      stroke="#A6A6A6"
      strokeWidth="1"
    />
    <path d="M20 44 V33 A16 16 0 0 1 52 33 V44 Z" fill="#3DDC84" />
    <line
      x1="24.7"
      y1="21.7"
      x2="20"
      y2="17"
      stroke="#3DDC84"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="47.3"
      y1="21.7"
      x2="52"
      y2="17"
      stroke="#3DDC84"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <rect x="20" y="42" width="32" height="2" fill="#000000" />
    <circle cx="30" cy="31" r="1.7" fill="#000000" />
    <circle cx="42" cy="31" r="1.7" fill="#000000" />
    <text
      x="66"
      y="26"
      fill="#FFFFFF"
      fontFamily="Helvetica, Arial, sans-serif"
      fontSize="10"
      letterSpacing="0.5"
      textLength="58"
      lengthAdjust="spacingAndGlyphs"
    >
      GET IT ON
    </text>
    <text
      x="66"
      y="45"
      fill="#FFFFFF"
      fontFamily="Helvetica, Arial, sans-serif"
      fontSize="21"
      fontWeight="600"
      textLength="82"
      lengthAdjust="spacingAndGlyphs"
    >
      Android
    </text>
  </svg>
);

export default AndroidDownloadBadge;
